(() => {
  document.querySelectorAll('[data-shop-search]').forEach(form => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const query = form.querySelector('[data-search-query]');
    const brand = form.querySelector('[data-shop-brand]');
    const type = form.querySelector('[data-shop-type]');
    const sort = form.querySelector('[data-shop-sort]');
    const params = new URLSearchParams(location.search);
    let terms = params.get('q') || '';
    for (const [field, input] of [['vendor', brand], ['product_type', type]]) {
      const pattern = new RegExp(`(?:^|\\s)${field}:"((?:\\\\.|[^"\\\\])*)"`, 'g');
      terms = terms.replace(pattern, (_, value) => { input.value = value.replace(/\\(.)/g, '$1'); return ''; });
    }
    query.value = terms.trim() === '*' ? '' : terms.trim();
    sort.value = params.get('sort_by') || 'relevance';
    form.addEventListener('submit', event => {
      event.preventDefault();
      const parts = [query.value.trim()];
      const quote = value => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      if (brand.value) parts.push(`vendor:"${quote(brand.value)}"`);
      if (type.value) parts.push(`product_type:"${quote(type.value)}"`);
      const url = new URL(form.action);
      url.searchParams.set('q', parts.filter(Boolean).join(' ') || '*');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('sort_by', sort.value);
      location.assign(url.href);
    });
  });
})();
